import { gql } from 'graphql.macro';

export const webhookSubscriptionFieldsFragment = gql`
    fragment webhookSubscriptionFields on WebhookSubscription {
        _id
        organization
        name
        url
        entities
        active
        lastSuccessAt
        lastFailureAt
        lastError
        failureCount
        secretLastRotatedAt
        createdBy
        createdAt
        updatedAt
    }
`;
